import { createContext } from "react";

export const MainScreenContext = createContext<any>([
  "BillingScreen",
  () => {},
]);
export const VctScreenContext = createContext<any>(["VctScreen", () => {}]);
